import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Drawer = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  interface IProps {
    children: React.ReactNode;
  }

  const DrawerPortal: React.FC<IProps> = ({ children }: IProps) => {
    const ref = useRef<Element | null>();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
      if (document) {
        const dom = document.querySelector('#local-drawer');
        ref.current = dom;
      }
    }, []);

    if (ref.current && mounted && drawerOpen) {
      return createPortal(children, ref.current);
    }

    return null;
  };

  return {
    openDrawer,
    closeDrawer,
    DrawerPortal,
  };
};

export default Drawer;
